<template>
  <v-btn icon width="40" height="40" v-on="$listeners">
    <div class="c360-avatar">
      <v-avatar v-if="user.avatar" :size="size">
        <img :src="user.avatar" :alt="user.fullName" />
      </v-avatar>
      <v-avatar v-else :size="size" class="c360-avatar">
        <span class="white--text text-body-2 font-weight-bold">
          {{ letters }}
        </span>
        <slot />
      </v-avatar>
      <div v-if="activated" class="c360-avatar-overlay">
        <c360-icon icon="Close_SM" />
      </div>
    </div>
  </v-btn>
</template>

<script>
  import Vue from 'vue';
  import { lettersFromFullName } from '../model';

  import { C360Icon } from '../../Icon';

  export default Vue.extend({
    name: 'C360Avatar',

    components: {
      C360Icon,
    },

    props: {
      /**
       * The user to display the avatar for.
       */
      user: {
        type: Object,
        required: true,
        validator: (user) => user.fullName.length > 0,
      },

      /**
       * Whether the avatar is activated or not.
       */
      activated: {
        type: Boolean,
        default: false,
      },

      /**
       * The size of the avatar.
       */
      size: {
        type: Number,
        default: 40,
      },
    },

    computed: {
      letters() {
        return lettersFromFullName(this.user.fullName);
      },
    },
  });
</script>

<style scoped>
  .c360-icon {
    position: relative;
  }

  .c360-avatar span {
    font-family: 'Inter', sans-serif !important;
    font-size: 14px !important;
  }

  .c360-avatar {
    border-radius: 50%;
    background-color: var(--c360-color-compulse) !important;
  }

  .c360-avatar-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 100%;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
</style>
